import React from 'react';

import { Button, Flex, Image, Text } from '@rover/kibble/core';

import DisplayContainer from './DisplayContainer';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  image: React.ReactElement<typeof Image>;
  title: React.ReactNode;
  body: JSX.Element;
  mainCTALabel: React.ReactNode;
  secondaryCTALabel: React.ReactNode;
  tertiaryCTALabel?: React.ReactNode;
  onMainCtaPress: () => void;
  onSecondaryCtaPress: () => void;
  onTertiaryCtaPress: () => void;
};

const MarketingOptIn = ({
  isOpen,
  onRequestClose,
  image,
  title,
  body,
  mainCTALabel,
  secondaryCTALabel,
  tertiaryCTALabel,
  onMainCtaPress,
  onSecondaryCtaPress,
  onTertiaryCtaPress,
}: Props): JSX.Element => {
  return (
    <DisplayContainer isOpen={isOpen} onRequestClose={onRequestClose} closeOnDragDown>
      <Flex flexDirection="column" testID="marketing-opt-in-bottom-sheet-content">
        <Flex pt="4x" pb="6x" flexDirection="column">
          <Flex justifyContent="center" alignItems="center" mb="6x">
            {image}
          </Flex>

          <Text mt="2x" mb="4x" fontWeight="semibold" size="300">
            {title}
          </Text>

          {body}
        </Flex>

        <Flex flexDirection="column" gap="3x">
          <Button
            fullWidth
            variant="primary"
            rxnProps={{ accessibilityRole: 'button', testID: 'marketing-opt-in-main-cta-button' }}
            onPress={onMainCtaPress}
            mb="1x"
          >
            {mainCTALabel}
          </Button>

          <Button
            fullWidth
            variant="default"
            rxnProps={{
              accessibilityRole: 'button',
              testID: 'marketing-opt-in-secondary-cta-button',
            }}
            onPress={onSecondaryCtaPress}
          >
            {secondaryCTALabel}
          </Button>

          <Button
            fullWidth
            variant="flat"
            rxnProps={{
              accessibilityRole: 'button',
              testID: 'marketing-opt-in-tertiary-cta-button',
            }}
            onPress={onTertiaryCtaPress}
          >
            {tertiaryCTALabel}
          </Button>
        </Flex>
      </Flex>
    </DisplayContainer>
  );
};

export default MarketingOptIn;
